import { LayoutListIcon, PanelBottomIcon } from '@/components/atoms/icons';
import { useUIColors } from '@/core/hooks';
import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';

export type LayoutType = 'grid' | 'list';

export interface LayoutToggleProps {
    layout: LayoutType;
    onLayoutChange: (layout: LayoutType) => void;
}

export function LayoutToggle({ layout, onLayoutChange }: LayoutToggleProps) {
    const colors = useUIColors();

    return (
        <View style={[styles.container, { borderColor: colors.outlineInactive, backgroundColor: colors.backgroundLevel2 }]}>
            <Pressable
                style={[
                    styles.toggleButton,
                    { backgroundColor: layout === 'grid' ? colors.backgroundLevel1 : colors.backgroundLevel2 },
                ]}
                onPress={() => onLayoutChange('grid')}
            >
                <PanelBottomIcon size={18} color={layout === 'grid' ? colors.buttonDefault : colors.buttonDisabled} />
            </Pressable>
            <Pressable
                style={[
                    styles.toggleButton,
                    { backgroundColor: layout === 'list' ? colors.backgroundLevel1 : colors.backgroundLevel2 },
                ]}
                onPress={() => onLayoutChange('list')}
            >
                <LayoutListIcon size={18} color={layout === 'list' ? colors.buttonDefault : colors.buttonDisabled} />
            </Pressable>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderRadius: 8,
        borderWidth: 1,
        overflow: 'hidden',
        width: 80,
        height: 32,
    },
    toggleButton: {
        width: 40,
        height: 32,
        alignItems: 'center',
        justifyContent: 'center',
    },
});

